export default __webpack_public_path__ + "static/media/Pirple-front-end-fundamentals.69050b21.webp";